import { render, staticRenderFns } from "./SelectCor.vue?vue&type=template&id=e8fc824a"
import script from "./SelectCor.vue?vue&type=script&lang=js"
export * from "./SelectCor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports